import { DwUser } from "@devwareapps/devware-cap";
import { PilexosUserTypeIds } from "./pilexos-user-type.enum";
import { AdminUserProperties } from "./admin-user-properties.model";
import { AppPermissions } from "../../../meta-data/app-permissions.enum";

export class PilexosUser {

    user: DwUser;

    UserTypeId: PilexosUserTypeIds;

    public flightSchoolOrganizationId: number;

    public flightSchoolId: number;

    public pilotExaminerId: number;
    public flightSchoolExaminerId: number;
    public flightSchoolInstructorId: number;

    constructor(user: DwUser, adminUserProperties: AdminUserProperties) {


        this.setupUser(user, adminUserProperties);
    }

    private setupUser(user: DwUser, adminUserProperties?: AdminUserProperties) {

        this.user = user;
        this.UserTypeId = adminUserProperties?.userTypeMode || this.getExtenedAttributeInt('UserTypeId');
        this.flightSchoolOrganizationId = adminUserProperties?.flightSchoolOrganizationId || this.getExtenedAttributeInt('SchoolFlightSchoolOrganizationId');
        this.flightSchoolId = adminUserProperties?.flightSchoolId || this.getExtenedAttributeInt('SchoolFlightSchoolId');
        this.pilotExaminerId = this.getExtenedAttributeInt('PilotExaminerId') || this.getExtenedAttributeInt('PilotExaminerPilotExaminerId');
        this.flightSchoolExaminerId = this.getExtenedAttributeInt('FlightSchoolUserFlightSchoolExaminerId');
        this.flightSchoolInstructorId = this.getExtenedAttributeInt('FlightSchoolUserFlightSchoolInstructorId');

    }

    private getExtenedAttribute(name: string): string {
        const userTypeAttr = this.user?.ExtendedAttributes?.find(a => a.AttrName == name);

        if (userTypeAttr) {
            return userTypeAttr.AttrValue
        }

        return null;
    }
    private getExtenedAttributeInt(name: string): number {
        const value = this.getExtenedAttribute(name);

        if (value) {
            return parseInt(value);
        }

        return null;
    }

    hasPermission(permission: AppPermissions): any {
        return this.user?.Permissions?.includes(permission);
    }
}
